import { Link } from "react-router-dom";
import { useSettingsAcl } from "./lib/useSettingsAcl";

interface HubCard {
  to: string;
  title: string;
  description: string;
  visible: (acl: ReturnType<typeof useSettingsAcl>) => boolean;
}

const HUB_CARDS: HubCard[] = [
  {
    to: "stammdaten",
    title: "Stammdaten",
    description: "Ordner, Kunden und S-Ordner verwalten.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "hero",
    title: "Hero",
    description: "Eigene Felder, Fahrtkilometer, Projekt-Steps und Rechnungstexte.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "vorlagen",
    title: "Vorlagen",
    description: "HTML-Vorlagen für Stundennachweise, Deckblätter und Türwartung.",
    visible: (a) => a.canAuftraege || a.canBestellungen,
  },
  {
    to: "dokumente",
    title: "Dokumente",
    description: "Lohnarten, DATEV-Versand und Mahnwesen. Monteur-Stundensätze, Standardtexte und Layout unter Dokumente → Einstellungen.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "status-sichtbarkeit",
    title: "Status-Sichtbarkeit",
    description: "Festlegen, wer welche Status bei Projekten, Dokumenten, Stundennachweisen und Lieferscheinen sehen darf.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "bestellungen",
    title: "Bestellungen",
    description: "Bestellungen aus der Excel-Liste übernehmen.",
    visible: () => true,
  },
  {
    to: "kommunikation",
    title: "Kommunikation",
    description: "Mail-Templates, Anfrage-Snippets und globale E-Mail-Signatur (App-Admins).",
    visible: () => true,
  },
  {
    to: "tagesgeschaeft",
    title: "Tagesgeschäft",
    description: "Kunden-Postfächer überwachen, Ordner zuordnen und Feld-Mappings für die Mail-Analyse.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "druck",
    title: "Druck",
    description: "Standorte und Drucker zuordnen.",
    visible: (a) => a.canAuftraege,
  },
  {
    to: "sitzungen",
    title: "Sitzungen",
    description: "Aktive Anmeldungen einsehen und beenden.",
    visible: (a) => a.canSessions,
  },
];

export function SettingsIndexPage() {
  const acl = useSettingsAcl();
  const cards = HUB_CARDS.filter((c) => !acl.loading && c.visible(acl));

  return (
    <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {cards.map((card) => (
        <Link
          key={card.to}
          to={`/admin/einstellungen/${card.to}`}
          className="group flex h-full flex-col gap-3 rounded-ios border border-separator bg-card p-5 shadow-ios transition hover:-translate-y-0.5 hover:border-accent hover:shadow-ios-md focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          <h2 className="text-base font-semibold text-label">{card.title}</h2>
          <p className="text-sm text-label-secondary">{card.description}</p>
          <span
            aria-hidden
            className="ml-auto mt-auto text-lg text-label-tertiary transition group-hover:translate-x-0.5 group-hover:text-accent"
          >
            ›
          </span>
        </Link>
      ))}
    </section>
  );
}
